module.exports = {"name":"Prihlasovacia stránka","icon":"<i class='material-icons'>payment</i>","widget":[{"type":"login","schemas":{},"initData":{}}]}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/login-tkl/login-tkl.json
// module id = 359
// module chunks = 0